import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TabView, TabPanel } from 'primereact/tabview';
import { toast } from "react-toastify";
import PayrollHistory from "./PayrollHistory";
import Loader from "../../Layout/Loader";
import PayrollInfo from "./PayrollInfo";
import PayrollComments from "./PayrollComments";
import PayrollBankAccounts from "./PayrollBankAccounts";
import "./payroll.scss";
import { globalHandleChange } from "../../../services/functions";
import SummaryPayrollTable from "./PayrollSummary";
import PayrollTotals from "./PayrollTotals";
import PayrollData from "./PayrollData";
import "../open-banking.scss"
import {   bankStatusEmployee, generateStatusStyle } from "../OpenBankingUtils";
import { useDuplicatePayroll, useGetPayrollById, useSavePayroll } from "./service";
import Page404 from "../../Page404";
import { Link } from "react-router-dom";
import { faCopy, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { bankStatus, bankStatusStyle, openBankingStatus, compareStatus } from "../OpenBankingUtils";
import { isPayrollValid } from "./PayrollUtils";
import moment from "moment";

const EditPayroll = (props) => {
  const { t,i18n } = useTranslation("translations");
  const [payrollAttachments, setPayrollAttachments] = useState([]);
  const payrollId = props.match.params.id;
  const [validationErrors,setValidationErrors] = useState({})
  console.log({payrollId})
  const  {payroll,setPayroll,loading:pageLoading,getPayroll} =  useGetPayrollById(payrollId)
  const history = useHistory()


  const valid = ({validateOnlyEmployeesFields=false,excludeFields,updatedPayroll}={})=>isPayrollValid({validateOnlyEmployeesFields,t,setValidationErrors,payroll:updatedPayroll ?? payroll,excludeFields})
  const {savePayrollFn,loading:savingPayroll} = useSavePayroll({valid})


  const handleChange = (e, selectKey, selectValue, length) => {
    const key = e?.target?.name ?? selectKey
    const value = (e?.target?.value ?? selectValue)
    if(validationErrors[key]){
      setValidationErrors(validationErrors=>({...validationErrors,[key]:null}))
    }
    globalHandleChange({ key, value, setState: setPayroll, length });
  }

  const { duplicatePayroll, loading:duplicateLoading } = useDuplicatePayroll({ 
    id: payrollId 
  });


  const createButton=(
      <Link to="/create-payroll" className="btn btn-sm btn-info mb-2 mb-md-0">
        {t("navbar.create")}
      </Link>
  )



  const duplicateButton=(
    <button
      onClick={()=>duplicatePayroll(payrollId)}
      className={`btn btn-sm ${duplicateLoading || savingPayroll ?"disabled":""} btn-outline-primary mr-2`}
      style={{minWidth:"max-content"}}

    >
      {duplicateLoading ? <FontAwesomeIcon className='mr-1' size='lg' icon={faSpinner} spin /> : <FontAwesomeIcon className="mr-1" icon={faCopy} />}
      {t("invoice.duplicate")}
    </button>
  )



  const employeStatusPending = payroll?.salaryRecords?.some(emp=>emp.bankStatusDisplayName === bankStatusEmployee.WAITING.value)
  
  const refreshButton = (
    ((compareStatus(payroll?.workflowStatus?.name, openBankingStatus.SENT_TO_BANK) && compareStatus(payroll?.bankStatus?.mappedStatusType?.id, bankStatus.WAITING)) || employeStatusPending ) && 
      (
      <button
          className={`btn btn-sm btn-warning ml-2  mb-2 mb-md-0`}
          disabled={savingPayroll || duplicateLoading}
          onClick={()=>savePayroll({actionStatus:{action:"REFRESH_STATUS"}})}
          style={{minWidth:"max-content"}}
        >
          {savingPayroll ? (
            <Loader size="xs" color="white" />
          ) : (
            t("openBanking.refreshButton")
          )}
      </button>
      )
  )

  const status = generateStatusStyle(payroll?.workflowStatus?.name,t)
  const bankStatusObj = bankStatusStyle(payroll?.bankStatus?.mappedStatusType?.id,t)

  const savePayroll=({actionStatus})=>{
    const attachments = payrollAttachments.map(({source,...restAtt})=>({...restAtt}))
    savePayrollFn({payroll:{...payroll,attachments},actionStatus,valid,onSuccess:(newPayroll)=>{
      if(actionStatus?.action ==="delete"){
        history.push("/pay-roll");
        return
      }
      history.push("/edit-payroll/" + newPayroll.id);
      getPayroll()
    },
    onError:(err)=>{
      setPayrollAttachments([])
      getPayroll()
    }
  })
    setPayrollAttachments([])

  }
  
    const dynamicActions = useMemo(()=>{
    return payroll?.conditions?.actionStatusToList?.map(actionStatus=>{
      const { className="" } = actionStatus
      return (
        <button
          className={`${className} ml-2  mb-2 mb-md-0`}
          disabled={savingPayroll || duplicateLoading}
          onClick={()=>savePayroll({actionStatus})}
          style={{minWidth:"max-content"}}
        >
          {savingPayroll ? (
            <Loader size="xs" color="white" />
          ) : (
            i18n.language=="alb"?actionStatus.albLabel:actionStatus.engLabel
          )}
      </button>
      )
    }) ?? []
  },[payroll?.conditions,i18n.language,savingPayroll,duplicateLoading,payroll,payrollAttachments,savePayroll,savePayrollFn])

  const disabled = [2,3,4,5].includes(payroll?.workflowStatus?.id)


  return !pageLoading ? (
    payroll ? (
    <div className="row payroll-page mt-1 open-banking">
      <div className="col-12 pt-0">
        <div className="card p-xl-2">
            <div className="d-flex align-items-center justify-content-between mb-1 mt-1 gap-y-2">
              <div className="d-flex align-items-center justify-content-center">
                <h3 className="mb-0 mr-4">
                  {t("payRoll.editPayroll")}
                </h3>
                <div className="d-flex justify-content-center align-items-center ml-2 font-weight-bold">
                {t("openBanking.profiscStatus")}:
                  <small className={`badge badge-${status.badgeClass} ml-2`} data-tooltip-id="global-tooltip" data-tooltip-content="ProFisc Status">
                    {status.status}
                  </small>
                </div>
                {bankStatusObj?.status && (
                  <div className="d-flex justify-content-center align-items-center ml-2 font-weight-bold">
                    {t("openBanking.bankStatus")}:
                    <small
                      className={`badge badge-${bankStatusObj.badgeClass} ml-2`}
                      data-tooltip-id="global-tooltip"
                      data-tooltip-content={
                        `📅 Last Updated Date: ${payroll?.bankStatus?.bankResponseDate ? moment(payroll.bankStatus.bankResponseDate).format("DD/MM/YYYY HH:mm:ss") : "N/A"}${payroll?.bankStatus?.bankError ? `\n⚠️  Message: ${payroll.bankStatus.bankError}` : ""
                        }`
                      }
                    >
                      {bankStatusObj.status}
                    </small>
                  </div>
                )}
              </div>

            <div className="d-flex align-items-center">
              {duplicateButton}
              {createButton}
              {dynamicActions}
              {refreshButton}
            </div>
          </div>

          <div className="my-2 border-top border-success"></div>
          <div className="row">
            <div className="col-12 col-md-5 border-right" style={{height:"100% !important"}}>
              <PayrollInfo 
                payroll={payroll} 
                setPayroll={setPayroll}
                handleChange={handleChange}
                disabled={disabled}
                validationErrors={validationErrors}
              />
            </div>
            <div className="col-12 col-md-3 border-right" style={{height:"100% !important"}}>
              <PayrollBankAccounts 
                payroll={payroll} 
                setPayroll={setPayroll}
                handleChange={handleChange} 
                disabled={disabled}
                validationErrors={validationErrors}
                />
            </div>
            <div className="col-12 col-md-4" style={{height:"100% !important"}}>
                <PayrollData
                  payroll={payroll} 
                  setPayroll={setPayroll}
                  handleChange={handleChange}
                  disabled={disabled}
                  validationErrors={validationErrors}

                />
            </div>
          </div>
          <div className="row">
            <div className="col-12 py-0" style={{minHeight:120,maxHeight:400}}>
              <SummaryPayrollTable 
                payroll={payroll}
                setPayroll={setPayroll}
                valid={valid}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                disabled={disabled}
              />
            </div>
          </div>
          <div className="row align-items-start" style={{minHeight:250}}>
            <div className="col-12 col-md-6 border-left" >
              <TabView>
                <TabPanel header={t("openBanking.attachmentsComments")}>
                  <PayrollComments
                    payroll={payroll}
                    setPayroll={setPayroll}
                    handleChange={handleChange}
                    payrollAttachments={payrollAttachments}
                    setPayrollAttachments={setPayrollAttachments}
                    disabled={disabled}
                  />
                </TabPanel>
                <TabPanel header={t("payRoll.payrollHistory")}>
                  <PayrollHistory payroll={payroll} disabled={disabled} />
                </TabPanel>
              </TabView>
            </div>
            <div className="col-12 col-md-6 border-t">
              <PayrollTotals payroll={payroll} setPayroll={setPayroll}/>
            </div>
          </div>
          </div>
      </div>
    </div>
  ) : (
    <Page404 />
  )
) : (
  <Loader />
);

}
export default EditPayroll;